import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const RequestsShortListStyles: ComponentStylesWithFns = {
  container: {
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
    overscrollBehavior: 'none',
  },
  newAttribute: {
    marginTop: 2,
    padding: '0',
  },
  statusIcon: {
    fontSize: '1rem',
    '&.red': {
      color: '#FF3030 !important',
    },
  },
  row: {
    '& .MuiDataGrid-row': {
      fontWeight: 'normal',
      fontSize: '15px',
      cursor: 'pointer',
      borderTop: '0.5px solid',
      borderColor: 'grey.200',
      color: 'text.primary',
      '& .MuiDataGrid-cell': {
        border: 'none',
        outline: 'none',
        fontSize: '16px',
      },
    },
  },
};
